// extracted by mini-css-extract-plugin
export default {"w1180":"index_w1180_rsLai","h2wrapper":"index_h2wrapper_DUen8"};